import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import DocumentListAndUploader from './AdditionalDocuments/DocumentListAndUploader';
import LandlordProvidedDocuments from '../../Widgets/LandlordProvidedDocuments';
import type { LandlordProvidedDocument } from '../../../models/Types';
import { useLandlordProvidedDocumentsQuery } from '../../../utils/queries';

function SupplementalDocuments() {
  const { leaseId } = useLeasingUrlParams();
  const { data } = useLandlordProvidedDocumentsQuery(Number(leaseId));

  const landlordProvidedDocuments: Array<LandlordProvidedDocument> =
    data?.documentNames?.map((name) =>
      typeof name === 'string' ? { text: name } : (name as LandlordProvidedDocument),
    ) || [];

  return (
    <>
      <Heading level={3} textStyle="responsive.heading-sm" css={{ marginBottom: 'layout.tighter' }}>
        Are there any additional documents to include with your lease?
      </Heading>
      <Paragraph>
        You may have documents in addition to your lease to send your renter, either as a legal requirement or as a
        courtesy. You may add up to 10 documents here.
      </Paragraph>
      <>
        {landlordProvidedDocuments.length > 0 && (
          <>
            <Heading level={4} textStyle="responsive.heading-xs" css={{ marginTop: 'lg' }}>
              Documents:
            </Heading>
            <LandlordProvidedDocuments
              hideExcessDocuments
              showIncludedText
              showAsOrderedList={false}
              landlordProvidedDocuments={landlordProvidedDocuments}
            />
          </>
        )}
      </>
      <Box css={{ marginTop: 'lg' }} />
      <DocumentListAndUploader />
    </>
  );
}

SupplementalDocuments.description = 'Adds documents to Zillow leases';

export default SupplementalDocuments;
